import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/business-communications/BusinessCommsContent.tsx");
